var React = require('react');

function IconChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M15 20l-8-8 8-8","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconChevronLeft.defaultProps = {"width":"24","height":"24"};

module.exports = IconChevronLeft;

IconChevronLeft.default = IconChevronLeft;
